var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeLegend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 14,
    viewBox: "0 0 34 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.6468C1.65979 11.0634 1.98969 13.0427 6.93814 4.72963C11.8866 -3.58344 12.5464 15.8137 16.5052 12.6468C20.4639 9.47996 23.433 -1.60369 26.4021 1.56297C29.3711 4.72963 27.7216 12.6468 33 12.6468",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLegend);
export default __webpack_public_path__ + "static/media/home-legend.5362d261a05425948fd6b95dcaf7e51a.svg";
export { ForwardRef as ReactComponent };